import React from 'react';
import PropTypes from 'prop-types';

const ReportMetalDivide = (props) => <div>ReportMetalDivide</div>;

ReportMetalDivide.propTypes = {};

export default ReportMetalDivide;
